import getFiltersOption from '../store/store';
import { mutator } from 'satcheljs';
import { setTrustedListsOnly } from '../actions/internalActions';

mutator(setTrustedListsOnly, actionMessage => {
    const filtersOption = getFiltersOption();
    filtersOption.trustedListsOnly = actionMessage.trustedListsOnly;
});
